import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import * as Sentry from '@sentry/ember';
import { initializeVdrClient } from 'scaleflow/utils/aws-clients/s3VDRClient';
import type RouterService from '@ember/routing/router-service';
import type StoreService from 'scaleflow/services/store';
import type BetaToggleService from 'scaleflow/services/beta-toggle';

class DataFileFileName extends Route {
  @service declare router: RouterService;
  @service declare store: StoreService;
  @service declare betaToggle: BetaToggleService;

  beforeModel() {
    if (!this.betaToggle.showKnowledgeBaseFeatures)
      this.router.transitionTo('home');
  }

  async model({ file_name }: { file_name: string }) {
    if (!file_name) throw new Error('File name is required to fetch the file.');
    const client = await initializeVdrClient(this.store);
    const file = await client.fileExists(file_name);
    if (!file) {
      throw new Error('File not found');
    }
    return {
      file_name,
    };
  }

  @action
  error(error: any) {
    if (error?.message !== 'File not found') {
      Sentry.captureException(error);
    }
    this.router.transitionTo('data.list');
  }
}

export default instrumentRoutePerformance(DataFileFileName);
